import { toObjectMap } from "../../utilities/dictionary";

const authenticationTypes = ["BANKID", "CLASSIC", "PHONE"] as const;
type AuthenticationType = typeof authenticationTypes[number];
const authenticationTypesMap = toObjectMap<AuthenticationType>([
    ...authenticationTypes,
]);
export type { AuthenticationType };
export { authenticationTypes, authenticationTypesMap };
